import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentPage: null,
    currentPageId: 0,
    view: '',
    mainLoad: {
      isLoading: false,
      loadPercent: 0,
    },
    language: 'cn',
    code: '',
    company_code: '',
    pageWidth: 800,
    pageHeight: 530,
    marginHeight: 260,
    marginWidth: 400,
    videoId: null,
    modal: {
      show: false,
      mode: '',
      value: '',
    },
    token: '',
  },
  mutations: {
    updateCurrentPage(state, page) {
      state.currentPage = page.currentPage;
    },
    updateCurrentPageId(state, page) {
      state.currentPageId = page.currentPageId;
    },
    updateLoadingStatus(state, payload) {
      state.mainLoad = payload.mainLoad;
    },
    updateView(state, page) {
      state.view = page.view;
    },
    updateModalStatus(state, payload) {
      state.modal = payload.modal;
    },
    updateVideoId(state, page) {
      state.videoId = page.videoId;
    },
  },
  getters: {
    token(state) {
      return state.token;
    },
  },
  actions: {
  },
  modules: {
  },
});
